module.exports = __webpack_public_path__ + "static/nam-a1100202fd12b5511fe0683830413efc.svg";